import React, { Component, PropTypes } from 'react'
import Waypoint from 'react-waypoint'
import './style.less'

class AsyncImage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			inViewport: false,
			loaded: false
		}
	}

	handleEnter = () => {
		this.setState(() => {
			return { inViewport: true }
		})
	}

	handleLoad = (img) => {
		this.setState(() => {
			return { img }
		})
	}

	componentWillUpdate(nextProps, nextState) {
		const { img, inViewport } = nextState
		if (img && inViewport) {
			const { src } = nextProps
			const i = new Image
			i.onload = () => {
				img.src = src
				this.setState(() => {
					return { loaded: true }
				})
			}
			i.src = src
		}
	}

	render() {
		const { loaded } = this.state
		const { width, height } = this.props
		return (
			<div className="async-image">
				<Waypoint onEnter={this.handleEnter} />
				<div className="async-image-content">
					<img className="placeholder" src={`data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 ${width} ${height}'><defs><symbol id='a' viewBox='0 0 90 66' opacity='0.3'><path d='M85 5v56H5V5h80m5-5H0v66h90V0z'/><circle cx='18' cy='20' r='6'/><path d='M56 14L37 39l-8-6-17 23h67z'/></symbol></defs><use xlink:href='#a' width='20%' x='40%'/></svg>`} />
					<img className={`finalAsyncImage ${loaded ? 'visible' : 'hidden'}`} ref={this.handleLoad} />
				</div>
			</div>
		)
	}
}

AsyncImage.propTypes = {
	src: PropTypes.string.isRequired,
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired
}

AsyncImage.defaultProps = {

}

export default AsyncImage



// WEBPACK FOOTER //
// ../components/AsyncImage/index.js